export default function ({ $auth, redirect }) {
    let user = $auth.user

    if (user && user.region) {
        redirect(user.profile_path || { name: "index" })
    }
}
